import React, { useState, useEffect } from 'react'
import { reqList, userData, userId } from '../../firebase.config'
import { addDoc, getDocs, query, where } from 'firebase/firestore/lite';
import { useNavigate } from 'react-router-dom';

function RequestListing() {

    const navigate = useNavigate()
    const [ formValues, setFormValues ] = useState({

        image:"",
        link:"",
        instruction:"",
        date: new Date(),
        user: userId
    })
    useEffect(()=>{
        async function fetchFirestore() {
            const q = query((userData), where('uid', '==', userId))
            const data = await getDocs(q);
            const result = data.docs.map((doc) => ({ ...doc.data(), id: doc.id }))
            console.log(result[0].email)
            setFormValues({ ...formValues, userdoc: result[0].id, email: result[0].email })
        }
        console.log('Hi');
        fetchFirestore()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    const handleFormSubmit = async (event)=> {
        event.preventDefault();
        console.log(formValues);
        
        try {
            await addDoc(reqList, { ...formValues })
            console.log('Created :', reqList)
            alert('Your request was successfully submitted!')
            navigate('/account')
        } catch (error) {
            console.error("Error while creating document: ", error);
        }
    }

  return (
    <div className='pt-6 pb-20'>
      <div className="px-14">
          <div className="bg-slate-800 p-6 px-12 rounded-xl">
              <p className="text-center py-3 text-yellow-500 text-lg font-bold tracking-widest">REQUEST PRODUCUT</p>
              <form className="text-center" onSubmit={handleFormSubmit}>
                  <div className="mb-6">
                      
                  </div>
                  <div className="mb-6">
                      <label
                          for="category"
                          className="block mb-2 text-sm font-medium text-slate-400 text-center"
                      >
                          Image
                      </label>
                      <input
                          type="url"
                          id="image"
                          className="text-center bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                          placeholder="Image link"
                          value={formValues.image}
                              onChange={(event) =>
                                  setFormValues({ ...formValues, image: event.target.value })
                              }
                      />
                  </div>
                  <div className="mb-6">
                      <label
                          for="category"
                          className="block mb-2 text-sm font-medium text-slate-400 text-center"
                      >
                          Link
                      </label>
                      <input
                          type="url"
                          id="Image"
                          className="text-center bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                          placeholder="Product link"
                          value={formValues.link}
                          required
                              onChange={(event) =>
                                  setFormValues({ ...formValues, link: event.target.value })
                              }
                      />
                  </div>
                  <div className="mb-6">
                      <label
                          for="Description"
                          className="block mb-2 text-sm font-medium text-slate-400 text-center"
                      >
                          Instruction
                      </label>
                      <input
                          type="text"
                          id="Instruction"
                          className="text-center bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                          placeholder='Explain about the product..'
                          value={formValues.instruction}
                              onChange={(event) =>
                                  setFormValues({ ...formValues, instruction: event.target.value })
                              }
                      />
                  </div>
                  <div className="mb-6">
                      <div className="items-center h-5 text-center">
                          
                      </div>
                  </div>

                  <button
                      type="submit"
                      className=" text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"

                  >
                      Request
                  </button>
              </form>
          </div>
      </div>
      </div>
  )
}

export default RequestListing